/**
 * Impersonation engine — the universal hook.
 *
 * Call from ANYWHERE (banner, sidebar, a deep page, a future search modal) to
 * impersonate, exit, or check permissions. The caller passes WHAT to impersonate;
 * the engine handles routing, headers, theme, and exit.
 *
 *   const { impersonate, exit, canImpersonate, isImpersonating } = useImpersonation();
 *   impersonate({ kind: "advisor", userId: 123, firmId: 9 });
 *
 * Must be used inside an `<ImpersonationProvider>`.
 */
import { useContext } from "react";
import { ImpersonationContext } from "./ImpersonationProvider";
import type { ImpersonationContextValue } from "./types";

export function useImpersonation(): ImpersonationContextValue {
  const ctx = useContext(ImpersonationContext);
  if (!ctx) {
    throw new Error(
      "useImpersonation must be used within an <ImpersonationProvider>.",
    );
  }
  return ctx;
}
